/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `radio` - radio
 * * `dropdown` - dropdown
 * * `multi_select` - multi_select
 * * `free_text` - free_text
 * @export
 */
export const QuestionTypeEnum = {
  radio: 'radio',
  dropdown: 'dropdown',
  multiSelect: 'multi_select',
  freeText: 'free_text',
} as const;
export type QuestionTypeEnum = (typeof QuestionTypeEnum)[keyof typeof QuestionTypeEnum];

export function instanceOfQuestionTypeEnum(value: any): boolean {
  for (const key in QuestionTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(QuestionTypeEnum, key)) {
      if ((QuestionTypeEnum as Record<string, QuestionTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function QuestionTypeEnumFromJSON(json: any): QuestionTypeEnum {
  return QuestionTypeEnumFromJSONTyped(json, false);
}

export function QuestionTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionTypeEnum {
  return json as QuestionTypeEnum;
}

export function QuestionTypeEnumToJSON(value?: QuestionTypeEnum | null): any {
  return value as any;
}
